module.exports = __webpack_public_path__ + "static/ECO-1929a16ee99ff3173ff7f6a3699584b3.png";